module.exports = __webpack_public_path__ + "img/success-submit.a604c30.png";